



























































































import { Vue, Component, Prop } from 'vue-property-decorator'
import { date } from 'quasar'
import store from 'src/assets/store'
import ItemData from 'src/assets/ItemData'
import { AttendeeItemData, AttendeeResponseResult, Slide } from 'src/assets/AttendeeItemData'
import PersonAvatar from 'components/account/PersonAvatar.vue'
import SessionDurationFormat from 'components/presenter/item/session/SessionDurationFormat.vue'
import SlidesViewer from 'components/presenter/item/topic/viewer/SlidesViewer.vue'
import { AttendeeItem, Session, SessionAttendee, ItemTypeTopic } from 'src/graphql/types'

@Component({
  components: {
    PersonAvatar,
    SessionDurationFormat,
    SlidesViewer
  }
})
export default class AttendeeItemTopic extends Vue {
  ItemTypeTopic = ItemTypeTopic
  now = store.now
  formatDate = date.formatDate
  loading = false
  viewerCurrSlideId = ''

  @Prop()
  readonly item!: AttendeeItem

  get slides () {
    return (Object.values(this.item.data?.slides || {}) as Slide[])
      .filter(slide => slide.id && !slide.deleted && !slide.hide && slide.type !== 'Params')
        .reduce(
          (result: Json[], slide: Json) => [
            ...result,
            ...(
              slide.meta?.pages
                ? slide.meta.pages
                  .filter((page: Json) => !page.deleted)
                    .map(
                      (page: Json, index: number) =>
                        Object.assign({}, slide, page, {
                          id: `${slide.id}#${page.pageNo}`,
                          meta: { masterSlide: slide, masterSlidePageIndex: index }
                        })
                    )
                : [slide]
            )
          ],
          [] as Json[])
          .sort((a, b) => a.sort - b.sort) as Slide[]
  }

  get retakes () {
    const retakes = new Map()
    for (const session of this.item.sessions.nodes ) if (session) {
      for (const attendee of session.sessionAttendees.nodes) if (attendee) {
        const sessionRetakes = retakes.get(session.id) || { count: -1, lastAttendeeFinishedAt: null }
        sessionRetakes.count++
        sessionRetakes.lastAttendeeFinishedAt = attendee.finishedAt
        retakes.set(session.id, sessionRetakes)
      }
    }
    return retakes
  }

  async refresh (done: () => void) {
    for (const session of this.item.sessions.nodes ) if (session) {
      session.sessionAttendees.nodes.sort((a, b) => a && b ? new Date(a.startedAt || a.createdAt).getTime() - new Date(b.startedAt || b.createdAt).getTime() : 0)
    }
    done()
  }

  async load (index: number, done: (stop?: boolean) => void) {
    done(true)
  }

  getSessionDurationMs (session: Session, attendee: SessionAttendee) {
    let miliseconds
    if (attendee.startedAt) {
      if (attendee.finishedAt) {
        miliseconds = new Date(attendee.finishedAt).getTime() - new Date(attendee.startedAt).getTime()
      } else if (session.stoppedAt && new Date(session.stoppedAt) < this.now()) {
        miliseconds = new Date(session.stoppedAt).getTime() - new Date(attendee.startedAt).getTime()
      } else {
        miliseconds = this.now().getTime() - new Date(attendee.startedAt).getTime()
      }
    } else if (this.item.typeTopic === ItemTypeTopic.Keynote) {
      if (session.startedAt && session.stoppedAt && new Date(session.stoppedAt) < this.now()) {
        miliseconds = new Date(session.stoppedAt).getTime() - new Date(session.startedAt).getTime()
      } else if (session.startedAt) {
        miliseconds = this.now().getTime() - new Date(session.startedAt).getTime()
      }
    }
    return miliseconds
  }

  getSessionResult (attendee: SessionAttendee) {
    const attendeeItemData = new AttendeeItemData(this.item.typeTopic as ItemTypeTopic, this.item.data as ItemData, attendee)
    const attendeeResponseResult = new AttendeeResponseResult(attendeeItemData)
    return Math.floor(attendeeResponseResult.percent)
  }
}
